import styled, { keyframes } from 'styled-components';
import { TextArea } from '@pearsontechnology/aero-components';

const paperAppear = (width) => keyframes`
  0% {
    margin-left: -${width}px;
  }
  100% {
    margin-left: 0;
  }
`;

const Paper = styled.div`
  width: ${(props) => props.width || 600}px;
  height: 100%;
  z-index: 1;
  flex-direction: column;
  flex-shrink: 0;
  box-sizing: border-box;
  background-color: ${(props) => props.theme['color.surface']};
  box-shadow: -1px 0 4px 0 rgba(0,0,0,0.15);
  border-radius: 0;
  overflow: hidden;

  position: relative;
  margin-left: 0;
  animation: 0.5s ease 0s 1 ${(props) => paperAppear(props.width || 600)};
`;

const DetailsDrawerContainer = styled.div``;

const DetailsDrawerHeader = styled.div`
 display: flex;
 align-items: center;
 padding: 10px 20px 5px;
`;

DetailsDrawerHeader.RightActionsGroup = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: -10px;
  line-height: 40px;

  *:not(:last-child) {
    margin-right: 8px;
  }

  em {
    opacity: 0.6;
  }
`;

const DetailsDrawerContent = styled.div`
  padding: 0 20px 20px 20px;
`;

const DetailsDrawerTitleWrapper = styled.div`
  position: relative;

  & i {
    position: absolute;
    top: 8px;
    right: 4px;
    left: auto;
    cursor: pointer;
    color: ${(props) => props.theme['color.blueDark']};
  }
`;


const DetailsDrawerDescriptionTextarea = styled(TextArea)`
  padding: 0 0 0 10px;
  margin: 0 0 13px;
  border: 1px solid transparent;
  font-size: 16px;
  color: ${(props) => props.theme['color.text.body']};
  min-height: 120px;
  max-height: 120px;

  &:hover {
    background: ${(props) => props.theme['color.surface']};
    border: 1px solid ${(props) => props.theme['color.blueLight']};
    border-radius: 4px;
    cursor: text;
  }

  &:focus {
    outline: none;
  }

  ${(props) => props.enableDescriptionTextarea && `
    font-weight: 400;
    background: #FFFFFF;
    border: 1px solid #2196F3;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 5px 26px 5px 10px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.7);
    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 2px rgb(33 150 243);
    }
  `}

`;

const DetailsDrawerTitleTextarea = styled(DetailsDrawerDescriptionTextarea)`
  font-weight: 600;
  min-height: 35px;
  max-height: 175px;
  font-size: 18px;
  line-height: 28px;
  
  ${(props) => !props.readOnly && `
    font-weight: 400;
    padding: 5px 26px 5px 10px;
    background: ${props.theme['color.surface']};
    border: 1px solid ${props.theme['color.blueLight']};
    box-sizing: border-box;
    border-radius: 4px;
    color: ${props.theme['color.text.body']};
    outline: none;
    box-shadow: inset 0 0 0 2px ${props.theme['color.blueLight']};
    
    &:focus {
      box-shadow: inset 0 0 0 2px ${props.theme['color.blueLight']};
    }
  `}
`;

const DetailsDrawerDescriptionTextareaWrapper = styled.div`
  position: relative;

  & i {
    position: absolute;
    top: 8px;
    right: 4px;
    left: auto;
    cursor: pointer;
    color: ${(props) => props.theme['color.blueDark']};
  }
`;

const TitleErrorInfo = styled.p`
  display: flex;
  flex-direction: row;
  transition: all 0.3s ease;
  font-size: 14px;
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.redLight']
      : props.theme['color.redDark']};
  margin: 0;
  overflow: hidden;
  margin-top: -8px;
  margin-bottom: 8px;

  & > svg {
    margin-right: 6px;
    width: 20px;
    height: 20px;
  }
`;

const DetailsDrawerUpdatingInfo = styled.div`
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 18px;
  color: ${(props) => props.theme['color.text.body']};
`;

DetailsDrawerUpdatingInfo.Label = styled.div`
  width: 90px;
  display: inline-block;
  font-weight: 600;
  color: ${(props) => props.theme['color.text.title']};
`;

DetailsDrawerUpdatingInfo.By = styled.span`
  text-decoration: underline;
`;

const InputHumanCodingScheme = styled.div`
  position: relative;

    & > div {
      margin: 0;
    }

    & input {
      height: 32px;
      padding-right: 40px;
    }

    & i {
      position: absolute;
      top: 5px;
      right: 10px;
      cursor: pointer;
      color: #0073CA;
    }
`;

const IdCode = styled.code`
  position: absolute;
  font-size: 14px;
  background: #eee;
  padding: 3px 8px;
  border-radius: 5px;
  opacity: 0.5;
  cursor: text;
  bottom: 10px;
  left: 10px
`;

const InputHumanCodingSchemeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;

  button {
    height: 40px;
    border-radius: 4px;
  }

  p > svg {
    width: 24px;
    height: 24px;
  }
`;

export {
  IdCode,
  Paper,
  DetailsDrawerContainer,
  DetailsDrawerHeader,
  DetailsDrawerContent,
  DetailsDrawerTitleWrapper,
  DetailsDrawerTitleTextarea,
  DetailsDrawerDescriptionTextarea,
  DetailsDrawerDescriptionTextareaWrapper,
  DetailsDrawerUpdatingInfo,
  InputHumanCodingScheme,
  InputHumanCodingSchemeWrapper,
  TitleErrorInfo,
};
